'use es6';

import { createAction } from 'redux-actions';
import { SHOW_DELETED_MESSAGES } from '../constants/ActionTypes';
export const showDeletedMessagesForThreadId = createAction(SHOW_DELETED_MESSAGES);